import { render, staticRenderFns } from "./GroupMealsCategoriesChart.vue?vue&type=template&id=09675ea3"
import script from "./GroupMealsCategoriesChart.vue?vue&type=script&lang=js"
export * from "./GroupMealsCategoriesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports